import { Link } from "react-router-dom";

import { Button } from "@/components/ui/button";
import { ScioMark } from "@/components/ui/scio-mark";
import { BetaBadge } from "@/components/ui/beta-badge";

/**
 * The header every signed-out page wears.
 *
 * It exists mostly for the way back: the login and registration cards were
 * dead ends — a visitor who followed "Prisijungti" out of the public page had
 * nothing to click to return to it but the browser's back button. The mark is
 * the way home, which is where a mark in the top-left always goes.
 *
 * `action` is the *other* door, so it is never the page you are already on.
 */
export function PublicHeader({ action }: { action: "login" | "register" | "both" }) {
  return (
    <header className="mx-auto flex max-w-6xl items-center gap-2 px-4 py-4 sm:px-6">
      <Link
        to="/"
        className="flex items-center gap-2 rounded-md focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary"
        aria-label="Į pradžią"
      >
        <ScioMark size={28} className="text-primary" />
        <span className="text-lg font-semibold tracking-tight">Scio</span>
      </Link>

      {/* Outside the link, never inside it: a button nested in an anchor is
          invalid, and the tap would go home instead of opening the note.
          A visitor deciding whether to sign up is exactly who this is for. */}
      <BetaBadge />

      <div className="ml-auto flex items-center gap-2">
        {action !== "login" && (
          <Button asChild size="sm" variant={action === "both" ? "ghost" : "outline"}>
            <Link to="/auth/login">Prisijungti</Link>
          </Button>
        )}
        {action !== "register" && (
          <Button asChild size="sm">
            <Link to="/auth/register">Registruotis</Link>
          </Button>
        )}
      </div>
    </header>
  );
}
